import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-message-on-list',
  templateUrl: './message-on-list.component.html',
  styleUrls: ['./message-on-list.component.css']
})
export class MessageOnListComponent implements OnInit {

  @Input()iconName: string;
  @Input()message: string;
  constructor() { }

  ngOnInit() {
  }

}
